import React, { useState, useEffect } from 'react';
import { paymentService } from '../../services/paymentService';
import { PAYMENT_STATUS } from '../../utils/constants';

const PaymentHistory = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refundingPayment, setRefundingPayment] = useState(null);

  useEffect(() => {
    fetchPaymentHistory();
  }, []);

  const fetchPaymentHistory = async () => {
    try {
      const data = await paymentService.getPaymentHistory();
      setPayments(data);
    } catch (err) {
      console.error('Failed to fetch payment history:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleRefund = async (paymentId) => {
    try {
      setRefundingPayment(paymentId);
      await paymentService.refundPayment(paymentId);
      await fetchPaymentHistory();
    } catch (err) {
      console.error('Failed to process refund:', err);
      alert('Failed to process refund. Please try again.');
    } finally {
      setRefundingPayment(null);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case PAYMENT_STATUS.SUCCESS:
        return 'bg-green-100 text-green-800';
      case PAYMENT_STATUS.FAILED:
        return 'bg-red-100 text-red-800';
      case PAYMENT_STATUS.REFUNDED:
        return 'bg-yellow-100 text-yellow-800';
      case PAYMENT_STATUS.INITIALIZED:
        return 'bg-blue-100 text-blue-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <p className="text-gray-600">Loading payment history...</p>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-6">Payment History</h2>

      {payments.length === 0 ? (
        <div className="text-center text-gray-500 py-8">
          No payments found
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-300 table-auto">
            <thead className="bg-gray-100">
              <tr>
                <th className="border border-gray-300 px-8 py-3 text-left">Payment ID</th>
                <th className="border border-gray-300 px-8 py-3 text-left">Status</th>
                <th className="border border-gray-300 px-8 py-3 text-left">Amount</th>
                <th className="border border-gray-300 px-8 py-3 text-left">Transaction ID</th>
                <th className="border border-gray-300 px-8 py-3 text-left">Date</th>
                <th className="border border-gray-300 px-8 py-3 text-left">Action</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment) => (
                <tr key={payment.id} className="hover:bg-gray-50">
                  <td className="border border-gray-300 px-8 py-2">{payment.id}</td>
                  <td className="border border-gray-300 px-8 py-2">
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(
                        payment.status
                      )}`}
                    >
                      {payment.status}
                    </span>
                  </td>
                  <td className="border border-gray-300 px-8 py-2">
                    ₹{(payment.amount_cents / 100).toLocaleString()} {payment.currency.toUpperCase()}
                  </td>
                  <td className="border border-gray-300 px-8 py-2">{payment.transaction_id}</td>
                  <td className="border border-gray-300 px-8 py-2">
                    {new Date(payment.created_at).toLocaleDateString()}
                  </td>
                  <td className="border border-gray-300 px-8 py-2">
                    {payment.status === PAYMENT_STATUS.SUCCESS && (
                      <button
                        onClick={() => handleRefund(payment.id)}
                        disabled={refundingPayment === payment.id}
                        className="px-4 py-1 text-sm font-medium bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:opacity-50"
                      >
                        {refundingPayment === payment.id ? 'Refunding...' : 'Refund'}
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default PaymentHistory;
